import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import * as moment from 'moment';

@Component({
  selector: 'customer-form',
  templateUrl: 'customer-form.component.html',
  styles: [``],
})
export class CustomerFormComponent {
  @Input() formGroup!: FormGroup;
  @Input() countrySettings?: string;
  @Input() showMoneyLaundering? = false;
  @Input() showPep? = false;

  appearance: MatFormFieldAppearance = 'outline';
  maxDate: Date = moment().subtract(18, 'years').toDate();


  get isEmailValid(): boolean | undefined {
    return this.formGroup.get('contact')?.get('email')?.invalid;
  }

  get isBirthdateValid(): boolean | undefined {
    return this.formGroup.get('birthdate')?.invalid;
  }

  get pepFormGroup(): FormGroup {
    return this.formGroup.get('pep') as FormGroup;
  }

  get moneyLaunderingFormGroup(): FormGroup {
    return this.formGroup.get('moneyLaundering') as FormGroup;
  }

  get otherMoneyLaunderingValue(): boolean {
    return this.moneyLaunderingFormGroup.get('other')?.value === true;
  }

  get showPepName(): boolean {
    return this.pepFormGroup.get('isFamilyMemberPep')?.value ||
        this.pepFormGroup.get('isKnownToBeCloseToPep')?.value ||
        this.pepFormGroup.get('isPep')?.value ||
        this.pepFormGroup.get('wasPepLastYear')?.value;
  }
}
